import { render, staticRenderFns } from "./collection-processing-input.vue?vue&type=template&id=697694fa&scoped=true"
import script from "./collection-processing-input.vue?vue&type=script&lang=js"
export * from "./collection-processing-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697694fa",
  null
  
)

export default component.exports